export const czDobroFaq: Array<[string, string]> = [
  [
    'Vystavíte mi potvrzení o daru?',
    'Ano, při vyplňování údajů stačí zaškrtnou kolonku „Chci vystavit potvrzení o daru“ a my vám potvrzení zašleme na e-mailovou adresu, kterou jste uvedli.',
  ],
  [
    'K čemu mi potvrzení o daru bude?',
    'Váš dar pomůže i vám – můžete si ho totiž jednoduše odečíst od základu daně v daňovém přiznání za daný rok. Pro fyzické osoby (včetně zaměstnanců) platí, že souhrnná hodnota daru musí činit alespoň 1 000 Kč. Právnické osoby si pak mohou od základu daně odečíst hodnotu darů, pokud jejich hodnota činí alespoň 2 000 Kč. Detailnější informace naleznete v § 15 a 20, odst. 1 Zákona 586/1992 sb. o daních z příjmů.',
  ],
  [
    'Co se děje s penězi, pokud se cílová částka nevybere?',
    'V momentě, kdy se sbírce dlouhodobě nedaří získávat dary, spojíme se s jejím zakladatelem a domluvíme se na jejím ukončení a předání částky, kterou se podařilo vybrat. Pokud se například vybíralo na přístroj, který není možné za nižší částky pořídit, poprosíme zakladatele sbírky o alternativní řešení. Z podstaty veřejné sbírky ale není možné finanční prostředky dárcům poslat zpět.',
  ],
  [
    'Mohu vám poslat peníze přímo na účet? Kde najdu číslo účtu?',
    'Peníze je vždy třeba poslat se správným variabilním symbolem, abychom dokázali platbu přiřadit ke správné sbírce. Proto je potřeba u každé sbírky zvolit platbu bankovním převodem, na základě které vám vygenerujeme variabilní symbol a veškeré údaje o platbě vám zašleme.',
  ],
  [
    'Je Donio garantem, že je sbírka důvěryhodná?',
    'Donio je platforma, která založení sbírek umožňuje. V profilu každé sbírky je uvedeno jméno jejího zakladatele, kterému po ukončení sbírky předáme dar. K posouzení, zda je zakladatel důvěryhodný, používáme několik kritérií, abychom co nejvíce předešli zneužití.',
  ],
];

export const czPlusFaq: Array<[string, string]> = [
  [
    'Vystavíte mi potvrzení o daru?',
    'V režimu Donio Plus obecně platí, že vystavit Potvrzení o daru nelze (nejedná se o dar do dobročinné sbírky). Případnou výjimku řeší přímo zakladatel projektu.',
  ],
  [
    'Kdy mohu očekávat svou odměnu?',
    'Odměny realizuje zakladatel projektu většinou do 90 dní po úspěšném ukončení projektu. Splnění ovšem může trvat i déle, zakladatel by Vás měl vždy kontaktovat a informovat ohledně odměn.',
  ],
  [
    'Co se děje s penězi, pokud se cílová částka nevybere?',
    'Pokud se nevybere více než 50\u00A0% financí u projektů do 75\u00A0000 Kč, nebo 25\u00A0% financí u projektů nad 75 000 Kč, peníze se vrátí přispěvatelům.',
  ],
  [
    'Mohu si u vás objednat daný produkt/službu, na kterou běží sbírka?',
    'My v Donio samotnou výrobu/poskytování neprovozujeme, jsme pouze platforma, přes kterou je možné na výrobu přispět. Pokud máte zájem o některý z produktů, na které jsou u nás podpůrné kampaně, kontaktujte prosím vždy jejich zakladatele uvedené v popisu projektu.',
  ],
  [
    'Mohu platit ApplePay?',
    'Aktuálně v rámci sekce Donio Plus není možné platit způsobem ApplePay, pouze kartou online či bankovním převodem',
  ],
];
